// @flow
import type { IConstraintModel } from "../../types";

/**
 */
class PasswordLowerAndUpperCaseConstraint implements IConstraintModel {
  /**
   */
  get id(): string {
    return "Constraint.Password.LowerAndUpperCaseMandatory";
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Must contain both upper and lowercase characters";
  }

  /**
   */
  get parameters(): { ... } {
    return {};
  }

  /**
   */
  validate(value: string): boolean {
    return /[a-z]/u.test(value) && /[A-Z]/u.test(value);
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default PasswordLowerAndUpperCaseConstraint;
